import { useQuery } from "@tanstack/react-query";
import { aboutRepo } from "@/lib/repositories";

export function useAboutIcons() {
  const query = useQuery({
    queryKey: ["about-icons"],
    queryFn: () => aboutRepo.fetchIcons(),
    refetchOnMount: "always",
  });
  return {
    icons: query.data ?? [],
    isLoading: query.isLoading,
  };
}
